// English translations, keyed by the Russian source string.
// One file per area (matches the translation batches) so they can be edited independently.
import auth from './auth'
import orderFlow from './order-flow'
import components from './components'
import adminConfig from './admin-config'
import customsShipment from './customs-shipment'
import adminUsers from './admin-users'
import adminPages from './admin-pages'
import kioskMisc from './kiosk-misc'

export default {
  ...auth,
  ...orderFlow,
  ...components,
  ...adminConfig,
  ...customsShipment,
  ...adminUsers,
  ...adminPages,
  ...kioskMisc,
}
